import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSurveyRuleTargetOptionsRPC } from "./getSurveyRuleTargetOptionsRPC";

export class GetSurveyRuleTargetOptionsRPCClientImpl extends GetSurveyRuleTargetOptionsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSurveyRuleTargetOptionsRPC.Request): Promise<LeoRPCResult<GetSurveyRuleTargetOptionsRPC.Response, GetSurveyRuleTargetOptionsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-rules/GetSurveyRuleTargetOptions",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSurveyRuleTargetOptionsRPC.ResponseDTO,
      GetSurveyRuleTargetOptionsRPC.Errors.ErrorsDTO,
      GetSurveyRuleTargetOptionsRPC.Response,
      GetSurveyRuleTargetOptionsRPC.Errors.Errors
    >(
      response,
      "survey-rules/GetSurveyRuleTargetOptions",
      GetSurveyRuleTargetOptionsRPC.Response.fromDTO,
      GetSurveyRuleTargetOptionsRPC.Errors.fromDTO
    );
  }
}
